/**
 * startFailureText - the customer sentence for a setup start-failure code.
 *
 * v1.0 - 2026-11-01 - BATCH-2026-10-31B R12 (Branko 2026-11-01): the server sends only the stable reason code
 *        (GET /api/setup/status startFailure.reason; d75 _START_FAILURE_REASONS). The sentence lives in the onboarding
 *        language file (startFailure.<code>); a code with no entry gets startFailure.fallback and is logged in the
 *        browser console with the code.
 */
import type { TFunction } from 'i18next';

export const START_FAILURE_NAMESPACE = 'onboarding';
export const START_FAILURE_FALLBACK_KEY = 'startFailure.fallback';

export function startFailureKey(code: string): string {
  return `startFailure.${code}`;
}

/** `exists` answers whether the language file has the key (i18n.exists in the app; a lookup in tests). */
export function startFailureText(
  t: TFunction | ((key: string) => string),
  exists: (key: string) => boolean,
  code: string | null | undefined,
): string {
  const key = code ? startFailureKey(code) : '';
  if (code && /^[A-Za-z_]+$/.test(code) && exists(key)) {
    return (t as (k: string) => string)(key);
  }
  console.warn('event=start_failure_text outcome=fallback reason=unknown_code code=%s', code ?? 'none');
  return (t as (k: string) => string)(START_FAILURE_FALLBACK_KEY);
}
